// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.carousel-image-enter {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhcm91c2VsLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBO0VBQ0UsY0FBQTtBQUFGOztBQUlBO0VBQ0UsOEJBQUE7QUFERjs7QUFJQTtFQUNFO0lBQ0UsVUFBQTtFQURGO0VBR0E7SUFDRSxVQUFBO0VBREY7QUFDRiIsImZpbGUiOiJjYXJvdXNlbC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEN1c3RvbSBzdHlsZXMgaWYgbmVlZGVkIC0gbW9zdGx5IHVzaW5nIFRhaWx3aW5kXHJcbjpob3N0IHtcclxuICBkaXNwbGF5OiBibG9jaztcclxufVxyXG5cclxuLy8gU21vb3RoIHRyYW5zaXRpb24gZm9yIGltYWdlIGNoYW5nZXMgKG9wdGlvbmFsIGVuaGFuY2VtZW50KVxyXG4uY2Fyb3VzZWwtaW1hZ2UtZW50ZXIge1xyXG4gIGFuaW1hdGlvbjogZmFkZUluIDAuM3MgZWFzZS1pbjtcclxufVxyXG5cclxuQGtleWZyYW1lcyBmYWRlSW4ge1xyXG4gIGZyb20ge1xyXG4gICAgb3BhY2l0eTogMDtcclxuICB9XHJcbiAgdG8ge1xyXG4gICAgb3BhY2l0eTogMTtcclxuICB9XHJcbn1cclxuIl19 */`, "",{"version":3,"sources":["webpack://./packages/ng-shared-ui/src/lib/organisms/carousel/carousel.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;AAAF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE;IACE,UAAA;EADF;EAGA;IACE,UAAA;EADF;AACF;AACA,4xBAA4xB","sourcesContent":["// Custom styles if needed - mostly using Tailwind\r\n:host {\r\n  display: block;\r\n}\r\n\r\n// Smooth transition for image changes (optional enhancement)\r\n.carousel-image-enter {\r\n  animation: fadeIn 0.3s ease-in;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
